const getRedirectUri = () => {
  if (process.env.REACT_APP_ENV === "production") {
    return "https://dmp.standbygroup.com/";
  }

  if (process.env.REACT_APP_ENV === "test") {
    return "https://dmp-test.standbygroup.com/";
  }

  return "http://localhost:3000";
};

// Microsoft Entra ID Configuration
const TENANT_ID =
  process.env.REACT_APP_TENANT_ID || "b70578b6-550d-461b-a55d-3885ab785273";
const CLIENT_ID =
  process.env.REACT_APP_CLIENT_ID || "8462036a-d7f3-427d-b02c-6b7ff4c327ca";
const API_CLIENT_ID =
  process.env.REACT_APP_API_CLIENT_ID || "51f95e7b-dc91-4e6c-8bbf-86e0a272afdf";
const AUTHORITY =
  process.env.REACT_APP_AUTHORITY || "https://login.microsoftonline.com/";

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

// Login request configuration
export const loginRequest = {
  scopes: [`api://${API_CLIENT_ID}/access_as_user`],
};

// API request configuration
export const apiRequest = {
  scopes: [`api://${API_CLIENT_ID}/access_as_user`],
};
